var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#009051"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 31.2C29.7674 31.2 31.2 29.7673 31.2 28C31.2 26.2327 29.7674 24.8 28 24.8C26.2327 24.8 24.8 26.2327 24.8 28C24.8 29.7673 26.2327 31.2 28 31.2Z",
    fill: "#FFFDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18L23.17 20H20C18.9 20 18 20.9 18 22V34C18 35.1 18.9 36 20 36H36C37.1 36 38 35.1 38 34V22C38 20.9 37.1 20 36 20H32.83L31 18H25ZM28 33C25.24 33 23 30.76 23 28C23 25.24 25.24 23 28 23C30.76 23 33 25.24 33 28C33 30.76 30.76 33 28 33Z",
    fill: "#FFFDFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fed929b11a3a932bea0401465ac1e001.svg";
export { ForwardRef as ReactComponent };